import React from 'react'
import { useWindowSize } from 'react-use'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import { ButtonUnstyled } from 'components/Button'
import { ReactComponent as DropdownIcon } from 'icons/chevron-vertical-16.svg'
import { ColorFormat } from '../Attribute/components/Color/utils'
import { Placement } from '@popperjs/core'

const IconButton = styled(ButtonUnstyled)`
  padding-top: 0px; /* allows the icon to be vertical aligned */
  padding-left: 2px; /* keeps it close to the left icon */ /* stylelint-disable-line scales/space */
  padding-bottom: 5px; /* the default 5px padding is applied to the bottom */ /* stylelint-disable-line scales/space */
`

interface CopyDropdownProps {
  dropdownOpen?: (open: boolean) => void
  onChange: (format: ColorFormat) => void
}

const ColorDropdown: React.FC<CopyDropdownProps> = ({
  dropdownOpen,
  onChange,
}) => {
  const size = useWindowSize()
  let placement: Placement = 'bottom'

  if (size) {
    if ((size as { height: number }).height < 650) {
      placement = 'auto'
    }
  }
  return (
    <Dropdown
      toggle={
        <IconButton data-testid="dropdown-button">
          <DropdownIcon width="8px" />
        </IconButton>
      }
      placement={placement}
      onToggle={dropdownOpen}
      spacing="8px"
      usePortal={false}>
      <Dropdown.Item onClick={() => onChange(ColorFormat.HEX)}>
        HEX
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(ColorFormat.RGB)}>
        RGB
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(ColorFormat.HSL)}>
        HSL
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Header>NSCOLOR</Dropdown.Header>
      <Dropdown.Item onClick={() => onChange(ColorFormat.OBJC_NSCOLOR)}>
        Objective-C
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(ColorFormat.SWIFT_NSCOLOR)}>
        Swift
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Header>UICOLOR</Dropdown.Header>
      <Dropdown.Item onClick={() => onChange(ColorFormat.OBJC_UICOLOR)}>
        Objective-C
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(ColorFormat.SWIFT_UICOLOR)}>
        Swift
      </Dropdown.Item>
    </Dropdown>
  )
}

export default ColorDropdown
